export const LOG_IN_REQUEST = 'LOG_IN_REQUEST';

export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';

export const LOG_IN_FAILURE = 'LOG_IN_FAILURE';

export const LOG_OUT = 'LOG_OUT';

export const CHECK_USERNAME_REQUEST = 'CHECK_USERNAME_REQUEST';

export const CHECK_USERNAME_SUCCESS = 'CHECK_USERNAME_SUCCESS';

export const CHECK_USERNAME_FAILURE = 'CHECK_USERNAME_FAILURE';

export const STORE_SECURITY_CODE = 'STORE_SECURITY_CODE';

export const DELETE_SECURITY_CODE = 'DELETE_SECURITY_CODE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const GET_SUPPORT_CONNECTION_REQUEST = 'GET_SUPPORT_CONNECTION_REQUEST';

export const GET_SUPPORT_CONNECTION_SUCCESS = 'GET_SUPPORT_CONNECTION_SUCCESS';

export const GET_SUPPORT_CONNECTION_FAILURE = 'GET_SUPPORT_CONNECTION_FAILURE';

export const CONNECT_TO_SUPPORT_VPN_REQUEST = 'CONNECT_TO_SUPPORT_VPN_REQUEST';

export const CONNECT_TO_SUPPORT_VPN_SUCCESS = 'CONNECT_TO_SUPPORT_VPN_SUCCESS';

export const CONNECT_TO_SUPPORT_VPN_FAILURE = 'CONNECT_TO_SUPPORT_VPN_FAILURE';
